import React from 'react';
import classNames from 'classnames/bind';
import { ContentPreview } from "./components/ContentPreview";
import { ContentSubscribePreview } from "./components/ContentSubscribePreview";
import style from "./styles.module.pcss";
export { PromoItem } from "./components/common";
var cx = classNames.bind(style);
var contentComponents = {
  subscribePreview: ContentSubscribePreview,
  preview: ContentPreview,
  preOrder: ContentPreview
};
export var Description = function Description(_ref) {
  var type = _ref.type,
    size = _ref.size,
    device = _ref.device,
    purchaseData = _ref.purchaseData,
    subscribeData = _ref.subscribeData,
    onChangeColor = _ref.onChangeColor,
    onChangeType = _ref.onChangeType;
  var Content = contentComponents[type];
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', size && "wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement(Content, {
    device: device,
    isAvailableDevice: type === 'preview',
    onChangeColor: onChangeColor,
    onChangeType: onChangeType,
    purchaseData: purchaseData,
    size: size,
    subscribeData: subscribeData
  }));
};